<template>
  <div ref="GImgUpl">
    <card id="ler_step4_GImgUpl" tabindex="0" class="mt-15">
      <div slot="header">
        <h3 class="card-title">사진 등록</h3>
      </div>
      <div class="col-12 px-0">
        <el-upload
          class="upload-demo text-center"
          drag
          :limit="3"
          :auto-upload="false"
          action="#"
          :on-change="uploadChange"
          :on-remove="removeFile"
          :on-exceed="exceedFileLimit"
          :file-list="G_Img_File.fileList"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            파일을 여기로 끌어 놓으세요.<br />혹은
            <em>클릭해주세요.</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            사이즈 500kb 미만의 jpg/png 파일로 제한
          </div>
        </el-upload>
      </div>
    </card>
  </div>
</template>

<script>
import { Card, Upload } from "element-ui";
import { createNamespacedHelpers, mapGetters } from "vuex";

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);

export default {
  components: {
    Card,
    [Upload.name]: Upload
  },

  data() {
    return {
      G_Img_File: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: []
      }
    };
  },

  created() {},
  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry"
    })
  },
  methods: {
    bringData() {
      this.G_Img_File = this.sessionPropertyInquiry.propertyInfo.G_Img_File; //일반이미지
    },
    SendData() {
      this.$emit("G_Img_File", this.G_Img_File);
    },
    // 파일첨부시(업로드x) 이벤트
    uploadChange: function(file, fileList) {
      console.log("fileList: ", fileList);
      this.G_Img_File.fileList = fileList;
      this.G_Img_File.fileList.forEach(file => {
        if (file.size > 50 * 1000 * 1000) {
          Message.error("50MB이상 파일은 업로드할 수 없습니다.");
          this.G_Img_File.fileList.splice(
            this.G_Img_File.fileList.indexOf(file),
            1
          );
          return;
        }
      });
      this.SendData();
    },
    // 선택한 파일 삭제
    removeFile: function(file, fileList) {
      this.G_Img_File.fileList = fileList;
      // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
      console.log(file);
      if (file.raw === undefined) this.G_Img_File.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    },
    // 지정한 파일갯수를 초과해서 첨부했을 때
    exceedFileLimit: function() {
      Message.warning("파일첨부는 3개까지만 가능합니다.");
    }
  }
};
</script>

<style></style>
